<template>
	<app-modal v-if="show" @close="closeModal" title="" @click.stop="">
		<template v-slot:header>
			<span class="mr-2">
				Add New Topping
			</span>
		</template>
		<app-section style="width: 1000px;">
			<div class="flex">
				<div class="flex flex-1 flex-col">
					<marketing-input label-class="w-24" label="Topping Name" v-model="formData.displayedText" />
					<marketing-input
						label-class="w-24"
						label="Description"
						class="flex flex-1"
						v-model="formData.description"
					/>
					<div class="flex items-center gap-4">
						<app-checkbox label="Required" v-model="formData.required" />
						<app-checkbox label="Is Active" v-model="formData.status" />
					</div>
				</div>
				<div class="flex">
					<add-icon-component
						:image="formData.image.stringBase64"
						:aspect-ratio="16 / 9"
						@on-select="onImageChanged($event)"
						@on-crop="onImageChanged($event)"
					/>
				</div>
			</div>
			<p class="font-bold mb-3">Toppings *</p>

			<div class="flex items-center justify-between" v-for="(item, index) in formData.items" :key="index">
				<marketing-input
					:label="`Topping ${index + 1}`"
					container-class="flex-1 mb-0"
					label-class="w-20"
					v-model="item.itemName"
				/>
				<marketing-input
					label="Description"
					container-class="flex-1 mb-0"
					label-class="w-20"
					v-model="item.description"
				/>
				<marketing-input
					label="Pricing"
					container-class="flex-1 mb-0 w-32"
					label-class="w-28"
					class="w-16"
					type="number"
					v-model="item.price"
				/>
				<marketing-input
					label="Discount Price"
					container-class="flex-1 mb-0 w-32"
					label-class="w-28"
					class="w-16"
					type="number"
					v-model="item.oldPrice"
				/>
				<div class="flex mb-3">
					<add-icon-component
						type="xs"
						:image="item.image.stringBase64"
						:aspect-ratio="16 / 9"
						@on-select="onItemImageChanged(item, $event)"
						@on-crop="onItemImageChanged(item, $event)"
					/>
				</div>
				<div class="mb-3">
					<app-confirmation
						title="Are you sure you want to remove this topping?"
						@confirm="removeTopping(item, index)"
						placement="left"
					>
						<app-icon
							class="ml-3 border-1 rounded-full p-1 text-8 text-warning mb-2 cursor-pointer"
							icon="cancel"
						/>
					</app-confirmation>
				</div>
			</div>

			<div class="flex flex-1">
				<app-button class="btn btn-secondary transparent dashed w-full" icon="plus" @click="addTopping">
					Add New Toppings
				</app-button>
			</div>

			<div class="flex justify-end mt-2">
				<app-button class="btn btn-success w-32" @click="createTopping" :loading="loading">Save</app-button>
			</div>
		</app-section>
	</app-modal>
</template>

<script>
	import BusinessService from '../../../services/sales/BusinessService';
	import MarketingInput from '../../../components/marketing/forms/formComponents/MarketingInput';
	import AppIcon from '../../../components/app/AppIcon';
	import AppConfirmation from '../../../components/app/AppConfirmation';
	import AddIconComponent from '../../../components/marketing/forms/formComponents/AddIconComponent';
	import AppModal from '../../app/AppModal';
	import { mapGetters } from 'vuex';

	export default {
		name: 'CreateToppingModal',
		components: { AppModal, AddIconComponent, AppConfirmation, AppIcon, MarketingInput },
		props: {
			businessName: {
				type: String,
				required: true,
			},
			show: {
				required: true,
				type: Boolean,
			},
		},
		data: () => ({
			loading: false,
			filters: {
				userSearch: '',
			},
			formData: {
				status: 1,
				image: {},
				items: [
					{
						itemName: '',
						price: 0,
						oldPrice: 0,
						image: {},
					},
				],
			},
		}),
		computed: {
			...mapGetters({
				user: 'user',
			}),
			businessId() {
				if (this.$route.params.id) {
					return this.$route.params.id;
				}
				return this.user.restaurants[0].restaurantID;
			},
		},
		methods: {
			createTopping() {
				this.loading = true;
				BusinessService.createTopping(this.businessId, this.formData)
					.then((topping) => {
						this.$emit('created', topping);
					})
					.catch((err) => {
						this.$notificationService.error(err);
					})
					.finally(() => {
						this.loading = false;
					});
			},
			addTopping() {
				this.formData.items.push({
					itemName: '',
					price: 0,
					oldPrice: 0,
					image: {},
				});
			},
			removeTopping(item, index) {
				if (this.formData.items.length === 1) {
					this.$notificationService.error('At least one topping item is required');
				} else {
					this.formData.items.splice(index, 1);
				}
			},
			onImageChanged(stringBase64) {
				this.formData.image = { stringBase64 };
			},
			onItemImageChanged(item, stringBase64) {
				item.image = { stringBase64 };
			},
			closeModal(data) {
				this.$emit('close', data);
			},
		},
		mounted() {},
	};
</script>
